/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */

/**
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.0.0
 */

/**
 * @description Translation interface to RangeDatePicker component.
 * @interface ICommonTranslationCalendar
 *
 * @property {IMonthsDictionary} monthsDictionary Define locale values to map months to local value
 * @property {string[]} months Define locale values to months
 * @property {string[]} weeks Define locale values to weeks
 * @property {string} weekLabel Define locale values to week label
 * @see RangeDatePicker
 */
interface ICommonTranslationCalendar {
    additionalButtons: IAdditionalButtons;
    months: string[];
    monthDeclension: string[];
    monthPickerPresets: IMonthPickerPresets;
    monthsDictionary: IMonthsDictionary;
    period: { [key in ECalendarPeriod]: string };
    placeholder: string;
    weekLabel: string;
    weeks: string[];
    time: {
        timezone: string;
        timepicker: string;
    };
}

export default ICommonTranslationCalendar;

// Sub locale interfaces

interface IMonthsDictionary {
    January: string;
    February: string;
    March: string;
    April: string;
    May: string;
    June: string;
    July: string;
    August: string;
    September: string;
    October: string;
    November: string;
    December: string;
}

export interface IMonthPickerPresets {
    period: string;
    quarter: string;
    startYear: string;
}

export interface IAdditionalButtons {
    deselectDate: string;
}

export enum ECalendarPeriod {
    D = 'D',
    M = 'M',
    W = 'W',
}
